import { Canal } from "./types";

export type EditCanalProperty =
  | "SET_CANAL"
  | "UNSET_CANAL"
  | "SET_NOME"
  | "SET_ATIVO";

export const INITIAL_STATE = {
  nomeCanal: "",
  flagAtivo: false,
};

export function reducer(
  state: Canal,
  { type, payload }: { type: EditCanalProperty; payload?: any }
): any {
  switch (type) {
    case "SET_CANAL":
      return {
        ...payload,
      };
    case "UNSET_CANAL":
      return undefined;
    case "SET_NOME":
      return {
        ...state,
        nomeCanal: payload,
      };
    case "SET_ATIVO":
      return {
        ...state,
        flagAtivo: payload,
      };
    default:
      return state;
  }
}
